var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('div',{staticClass:"grid"},[_c('NewTasksCard'),_c('UserTasksCard'),(_vm.isAdmin)?_c('ProjectsOrderCard'):_vm._e()],1),_c('div',{staticClass:"mt-2"},[_c('AppointmentsToday')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }